import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from '../tables/RecordsTable';
import {useSubscriptionItemsSelection} from '../hooks/useSubscriptionItemsSelection';

/**
 * FNP-918: the subscription-items index page.
 *
 * Selection was `useState<SubscriptionItem[]>` here and threaded into the table as
 * two props; it is now the Redux `subscription-items.selection` slice (§3, FNP-951).
 * The page still owns the hook instance and passes it down, because the DELETE
 * button lives in the page header — a sibling of the table, not a child — so
 * something above both has to hold the reference.
 *
 * ⚠️ Selection survives unmount now that it is in the store, so the batch
 * delete must clear it explicitly: handleClearSelection is passed as
 * onDeleteComplete. Without that, ids of deleted rows stay selected and the
 * next delete targets records that no longer exist.
 */
export const IndexPage = () => {

    const selection = useSubscriptionItemsSelection();

    return (
        <SimplePageLayout
            pageHeader={
                <IndexPageHeader
                    selectedIds={selection.selectedIds}
                    onDeleteComplete={selection.handleClearSelection}
                />
            }
        >
            <SimplePageContentWrapper>
                <RecordsTable selection={selection}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
